// AWS SDK/Amplifyの認証情報取得はオフライン時に無期限で応答が返らないことがあるため、
// 強制的にタイムアウトさせてUIが固まったままにならないようにするためのヘルパー
export default function withTimeout(promise, ms = 10000, timeoutMessage = 'timeout') {
  const timeout = new Promise((_, reject) => {
    setTimeout(() => reject(new Error(timeoutMessage)), ms)
  })
  return Promise.race([promise, timeout])
}
